export const POST_OPTIONS: RequestInit = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  credentials: 'include'
}

export const GET_OPTIONS: RequestInit = {
  credentials: 'include'
}
